module.exports = __webpack_public_path__ + "img/Appearance.8970a301.svg";